import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const fetchMealRegistration = mealRegistrationId => {
    return RESTClient.getAuthenticatedObservable(`v2/foodConsumption/mealRegistration/${mealRegistrationId}`);
};

export const createMealRegistrations = (institutionId, childIds, mealType, mealItems, createdAt) => {
    return RESTClient.postAuthenticatedObservable(`v2/foodConsumption/mealRegistration/${institutionId}`, {
        childIds,
        mealType,
        mealItems,
        createdAt,
    });
};

export const updateMealRegistration = (mealRegistrationId, mealType, mealItems, createdAt) => {
    return RESTClient.putAuthenticatedObservable(`v2/foodConsumption/mealRegistration/${mealRegistrationId}`, {
        mealType,
        mealItems,
        createdAt,
    });
};

export const deleteMealRegistration = mealRegistrationId => {
    return RESTClient.deleteAuthenticatedObservable(`v2/foodConsumption/mealRegistration/${mealRegistrationId}`);
};
